var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStategicPrioritiesOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/arrow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 21.75C10.59 21.75 10.25 21.41 10.25 21V19C10.25 18.59 10.59 18.25 11 18.25C11.41 18.25 11.75 18.59 11.75 19V21C11.75 21.41 11.41 21.75 11 21.75Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11 17.75C10.59 17.75 10.25 17.41 10.25 17V15C10.25 14.59 10.59 14.25 11 14.25C11.41 14.25 11.75 14.59 11.75 15V17C11.75 17.41 11.41 17.75 11 17.75Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11 13.75C10.59 13.75 10.25 13.41 10.25 13V10C10.25 5.73 13.73 2.25 18 2.25H21C21.41 2.25 21.75 2.59 21.75 3C21.75 3.41 21.41 3.75 21 3.75H18C14.55 3.75 11.75 6.55 11.75 10V13C11.75 13.41 11.41 13.75 11 13.75Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11 13.75C10.59 13.75 10.25 13.41 10.25 13V10C10.25 6.55 7.45 3.75 4 3.75H1C0.59 3.75 0.25 3.41 0.25 3C0.25 2.59 0.59 2.25 1 2.25H4C8.27 2.25 11.75 5.73 11.75 10V13C11.75 13.41 11.41 13.75 11 13.75Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.99997 5.74994C2.80997 5.74994 2.61994 5.67994 2.46994 5.52994L0.469941 3.52994C0.179941 3.23994 0.179941 2.75994 0.469941 2.46994L2.46994 0.469941C2.75994 0.179941 3.24 0.179941 3.53 0.469941C3.82 0.759941 3.82 1.23994 3.53 1.52994L2.05997 2.99994L3.53 4.46994C3.82 4.75994 3.82 5.23994 3.53 5.52994C3.38 5.67994 3.18997 5.74994 2.99997 5.74994Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19 5.74994C18.81 5.74994 18.6199 5.67994 18.4699 5.52994C18.1799 5.23994 18.1799 4.75994 18.4699 4.46994L19.94 2.99994L18.4699 1.52994C18.1799 1.23994 18.1799 0.759941 18.4699 0.469941C18.7599 0.179941 19.24 0.179941 19.53 0.469941L21.53 2.46994C21.82 2.75994 21.82 3.23994 21.53 3.52994L19.53 5.52994C19.38 5.67994 19.19 5.74994 19 5.74994Z",
    fill: "#7C7C7C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStategicPrioritiesOutlined);
export default __webpack_public_path__ + "static/media/stategicPrioritiesOutlined.28c32e43cea9da9584e0471ee22dfe3d.svg";
export { ForwardRef as ReactComponent };